import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../api/api';

import PersianNumberInput from './NumberInput';

function SuggestionResult() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [accessCode, setAccessCode] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      fetchDataById(id);
    } else {
      setLoading(false);
      setShowModal(true);
    }
  }, [id]);

  const fetchDataById = async (idOrPhone) => {
    setLoading(true);
    setError('');
    if (!/^09\d{9}$/.test(idOrPhone)) {
      setError('شماره تلفن معتبر نیست');
      return;
    }
    try {
      const endpoint = id
        ? `/suggestion/${idOrPhone}`
        : `/suggestion/phone/${idOrPhone}`;
      const res = await api.get(endpoint);
      console.log('Fetched data:', endpoint, res.data);
      setData(res.data);
      setShowModal(false);
    } catch (err) {
      console.error('Failed to fetch data', err);
      alert('داده‌ای یافت نشد. لطفاً کد دسترسی یا شماره تلفن را بررسی کنید.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitPhone = async () => {
    if (!phone) return;
    await fetchDataById(phone);
  };

  const handleSubmitCode = async () => {
    if (!accessCode) return;
    await fetchDataById(accessCode);
    setShowModal(false);
  };

  const handleClick = (e) => {
    window.location.href = `https://academy.azishafiei.com/register?product=${e}`;
  };

  if (loading)
    return <div className="text-center mt-10">در حال بارگذاری...</div>;

  // Show modal if no id
  if (showModal) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white p-6 rounded-xl shadow-lg max-w-sm w-full">
          <h2 className="text-lg font-bold mb-4">
            لطفاً کد دسترسی / شماره موبایل خود را وارد کنید
          </h2>
          <PersianNumberInput
            value={accessCode}
            onChange={(val) => setAccessCode(val)}
            className="border p-2 w-full rounded mb-4"
          />
          {/* <input
            type="text"
            value={accessCode}
            onChange={(e) => setAccessCode(e.target.value)}
            className="border p-2 w-full rounded mb-4"
            placeholder="کد دسترسی"
          /> */}
          <button
            onClick={handleSubmitCode}
            className="w-full bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded">
            ارسال
          </button>

          {error.length > 1 && (
            <div
              class="flex mt-2 items-center bg-green-500 text-white text-sm font-bold px-4 py-3 rounded"
              role="alert">
              <svg
                class="fill-current w-4 h-4 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20">
                <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
              </svg>
              <p>{error}</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (!data) return <div className="text-center mt-10">داده‌ای یافت نشد</div>;

  // Status not complete
  // if (data.status !== 'complete') {
  //   return (
  //     <div className="text-center mt-10 text-lg font-bold h-screen" dir="rtl">
  //       <style>{`
  //         /* your existing styles */
  //       `}</style>
  //       <div id="container">
  //         {data.name} عزیز
  //         <div id="flip">
  //           <div>
  //             <div>
  //               به دلیل حجم زیاد درخواست ها، ممکن است بررسی و آنالیز اطلاعات شما
  //               تا ۲۴ ساعت زمان ببرد.
  //             </div>
  //           </div>
  //           <div>
  //             <div>لطفاً بعداً</div>
  //           </div>
  //           <div>
  //             <div>مراجعه کنید!</div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  // Main result display
  return (
    <div className="max-w-2xl mx-auto p-4" dir="rtl">
      <h2 className="text-2xl font-bold mb-4 text-center">
        سلام {data.name} عزیز! 👋
      </h2>
      <div className="border rounded-xl p-4 mb-4 shadow">
        <p>سن: {data.age} سال</p>
        <p>قد: {data.height} سانتی‌متر</p>
        <p>وزن: {data.weight} کیلوگرم</p>
        <p>دور کمر: {data.waist} سانتی‌متر</p>
        <p>دور باسن: {data.hip} سانتی‌متر</p>
        <p>درصد چربی بدن (ناوی): {data.bodyFat?.navy}</p>
        <p>درصد چربی بدن (دورنبرگ): {data.bodyFat?.deurenberg}</p>
      </div>
      <div className="border rounded-xl p-4 shadow bg-gray-100 leading-loose whitespace-pre-line">
        <span className="text-right font-bold text-xl">نظر کوچ تغذیه: </span>
        {data.output}
        <div className="flex flex-row justify-between mt-4">
          <button
            onClick={() => handleClick('academy')}
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded">
            ثبت نام در دوره آکادمی تغذیه
          </button>
          <button
            onClick={() => handleClick('private')}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
            ثبت نام جلسات خصوصی
          </button>
        </div>
      </div>
    </div>
  );
}

export default SuggestionResult;
